export default {
  schema: {
    "kind": "collectionType",
    "collectionName": "telegram_user_activity",
    "info": {
      "singularName": "telegram-user-activity",
      "pluralName": "telegram-user-activity",
      "displayName": "Telegram User Activity",
      "description": ""
    },
    "options": {
      "draftAndPublish": false
    },
    "pluginOptions": {},
    "attributes": {
      "user_id": {
        "type": "relation",
        "relation": "oneToOne",
        "target": "plugin::telegram-bot.telegram-user",
        "required": true
      },
      "group_id": {
        "type": "relation",
        "relation": "oneToOne",
        "target": "plugin::telegram-bot.telegram-group",
        "required": true
      },
      "message_count": {
        "type": "integer"
      },
      "time_since_join": {
        "type": "datetime"
      },
      "is_joined": {
        "type": "boolean",
        "default": false
      }
    }
  },
};
